import { Stack, Typography } from '@mui/material';

interface props {
  height: number;
  message?: string;
}

const Card404 = ({ height, message }: props) => {
  return (
    <>
      <Stack spacing={-2}>
        <img
          src={'/assets/images/page404.png'}
          style={{
            objectFit: 'contain',
            height,
            marginLeft: 10,
          }}
        />
        <Typography variant="h4" alignSelf={'center'} pt={2}>
          {message}
        </Typography>
      </Stack>
    </>
  );
};
export { Card404 };
